export default __webpack_public_path__ + "static/media/AIA.132d02db.png";